import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-60a04c29"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "form-input-checkbox-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedCheckbox = _resolveComponent("FriedCheckbox");
    const _component_ProsemirrorViewerFormInput = _resolveComponent("ProsemirrorViewerFormInput");
    const _component_FriedSpinner = _resolveComponent("FriedSpinner");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FriedCheckbox, {
            id: _ctx.input.id,
            "data-external": "form-input-checkbox-input-view",
            "model-value": _ctx.checked,
            disabled: _ctx.isDisabled,
            error: _ctx.hasUpdateError,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update-checked', $event)))
        }, null, 8, ["id", "model-value", "disabled", "error"]),
        _createVNode(_component_ProsemirrorViewerFormInput, {
            class: _normalizeClass(['checkbox-label', { 'is-required': _ctx.input.inputSettings.required && _ctx.editable }]),
            "data-external": "form-input-checkbox-label-view",
            content: _ctx.getSafeText(_ctx.input.inputSettings.richTextLabel),
            fields: _ctx.fields,
            label: false,
            link: false,
            "merge-values": _ctx.mergeValues,
            "multi-line": false,
            placeholder: ""
        }, null, 8, ["class", "content", "fields", "merge-values"]),
        (_ctx.isUpdating)
            ? (_openBlock(), _createBlock(_component_FriedSpinner, {
                key: 0,
                class: "updating-spinner",
                size: 20
            }))
            : _createCommentVNode("", true)
    ]));
}
